module.exports = __webpack_public_path__ + "static/media/file-icon.dfa76e44.svg";